export default __webpack_public_path__ + "static/media/Bloodbrute Chestguard.6bfe99b0.jpg";